var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaElectron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.4 25.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.4,
    height: 25.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.67,
    y: 21.49,
    width: 39.06,
    height: 3.5,
    style: {
      fill: "#fab400"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.67,
    y: 0.67,
    width: 39.06,
    height: 3.5,
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,7.34l-3.83,9.15H9.7L7.82,9.18a1,1,0,0,0-.57-.8A9.63,9.63,0,0,0,4.92,7.6l0-.26H9a1.09,1.09,0,0,1,1.09.93l1,5.29,2.46-6.22Zm9.81,6.16c0-2.42-3.34-2.55-3.32-3.63,0-.33.32-.68,1-.76a4.47,4.47,0,0,1,2.34.4l.41-1.94a6.52,6.52,0,0,0-2.21-.4c-2.34,0-4,1.24-4,3,0,1.32,1.18,2.06,2.07,2.49s1.23.74,1.23,1.14c0,.61-.74.89-1.42.9a4.89,4.89,0,0,1-2.43-.58l-.43,2a7.07,7.07,0,0,0,2.63.49c2.49,0,4.12-1.23,4.13-3.13m6.18,3h2.18L32.3,7.34h-2a1.08,1.08,0,0,0-1,.67l-3.55,8.48h2.49l.49-1.37h3Zm-2.65-3.25,1.25-3.43.72,3.43Zm-10-5.9-2,9.15H15.1l2-9.15Z",
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.45,19h-1v.9h1.08v.27h-1.4V17.69h1.34V18h-1v.79h1Z",
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.07,17.55h.32v2.62h-.32Z",
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.21,19.34a.56.56,0,0,0,.61.62,1,1,0,0,0,.49-.1l.06.24a1.47,1.47,0,0,1-.6.11.83.83,0,0,1-.87-.9.86.86,0,0,1,.83-1,.75.75,0,0,1,.74.84.66.66,0,0,1,0,.15Zm.95-.24a.46.46,0,0,0-.45-.52.54.54,0,0,0-.5.52Z",
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.24,20.11a1.34,1.34,0,0,1-.52.1.84.84,0,0,1-.88-.91.9.9,0,0,1,.95-.95,1.18,1.18,0,0,1,.45.09l-.07.25a.83.83,0,0,0-.38-.08.67.67,0,0,0,0,1.34.91.91,0,0,0,.4-.09Z",
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.14,18v.43h.47v.24h-.47v1c0,.23.07.35.25.35l.19,0v.25a1,1,0,0,1-.29,0,.45.45,0,0,1-.35-.14.67.67,0,0,1-.12-.46v-1h-.28v-.24h.28v-.34Z",
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.06,18.94c0-.21,0-.39,0-.55h.28l0,.35h0a.54.54,0,0,1,.49-.39h.09v.3h-.11a.44.44,0,0,0-.43.42.71.71,0,0,0,0,.15v1h-.33Z",
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.94,19.26a.88.88,0,0,1-.89.95.85.85,0,0,1-.86-.92.87.87,0,0,1,.89-.94A.84.84,0,0,1,31.94,19.26Zm-1.42,0c0,.39.23.69.54.69s.54-.29.54-.7-.15-.68-.53-.68S30.52,19,30.52,19.28Z",
    style: {
      fill: "#1c2f76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.43,18.87c0-.19,0-.34,0-.48h.28l0,.29h0a.66.66,0,0,1,.59-.33c.25,0,.63.15.63.76v1.06h-.32v-1c0-.29-.11-.53-.42-.53a.47.47,0,0,0-.43.34.34.34,0,0,0,0,.15v1.07h-.33Z",
    style: {
      fill: "#1c2f76"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaElectron);
export default __webpack_public_path__ + "static/media/visa-electron.6786c745.svg";
export { ForwardRef as ReactComponent };